// Google Analytics tracking utility

// Track page views
export const trackPageView = (path) => {
  if (window.gtag) {
    window.gtag('config', 'G-1WQG87LCMV', {
      page_path: path
    });
  }
};

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

// Track candidate application
export const trackCandidateApplication = (jobId, jobTitle, applicationType = 'standard') => {
  trackEvent('candidate_application', {
    event_category: 'Application',
    event_label: jobTitle,
    job_id: jobId,
    application_type: applicationType,
    value: 1
  });
};

// Track file import
export const trackFileImport = (fileType, fileName, fileSize) => {
  trackEvent('file_import', {
    event_category: 'File',
    event_label: fileType,
    file_name: fileName,
    file_size: fileSize,
    value: 1
  });
};

// Track post creation
export const trackPostCreation = (postType, postTitle) => {
  trackEvent('post_creation', {
    event_category: 'Post',
    event_label: postType,
    post_title: postTitle,
    value: 1
  });
};

// Track user registration
export const trackUserRegistration = (userType) => {
  trackEvent('sign_up', {
    event_category: 'User',
    event_label: userType,
    method: 'email'
  });
};

// Track user login
export const trackUserLogin = (userType) => {
  trackEvent('login', {
    event_category: 'User',
    event_label: userType,
    method: 'email'
  });
};

// Track blog article view
export const trackBlogView = (articleSlug, articleTitle) => {
  trackEvent('blog_view', {
    event_category: 'Blog',
    event_label: articleTitle,
    article_slug: articleSlug
  });
};

// Track job view
export const trackJobView = (jobId, jobTitle) => {
  trackEvent('job_view', {
    event_category: 'Job',
    event_label: jobTitle,
    job_id: jobId
  });
};

// Track search
export const trackSearch = (searchTerm, searchCategory) => {
  trackEvent('search', {
    search_term: searchTerm,
    event_category: searchCategory
  });
};

// Track button clicks
export const trackButtonClick = (buttonName, location) => {
  trackEvent('button_click', {
    event_category: 'Engagement',
    event_label: buttonName,
    location: location
  });
};

// Track form submission
export const trackFormSubmission = (formName, success = true) => {
  trackEvent('form_submission', {
    event_category: 'Form',
    event_label: formName,
    success: success
  });
};
